import { TitleText, UtilityText } from '@policygenius/mortar';
import classnames from 'classnames';
import React, { useState, useContext } from 'react';

import Icon from 'components/Icon';
import ScreenSizeContext from 'contexts/ScreenSize';
import { SubmitButton } from 'forms/Inputs';

import styles from './multiple-choice.module.scss';
import { IProps } from './types';

const MultipleChoice: React.FC<IProps> = ({
  analyticsProperties,
  defaultOption,
  header,
  id,
  onSubmit,
  options,
  secondaryOption,
  subheader,
}) => {
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const { isMobile } = useContext(ScreenSizeContext);

  const handleSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (selectedOption) {
      onSubmit(selectedOption);
    }
  };

  return (
    <form className={styles.wrapper} name={id} onSubmit={handleSubmit}>
      <fieldset className={styles.options}>
        <legend id={id} className={styles.header}>
          <TitleText size="large" as="p">
            {header}
          </TitleText>
          {subheader && !isMobile && (
            <UtilityText size="large" className={styles.subheader}>
              {subheader.text}
            </UtilityText>
          )}
        </legend>
        {options &&
          options.map((option, index) => {
            const radioGroupId = `radio-group-${id}`;
            const radioItemId = `${radioGroupId}-item-${index}`;
            const optionValue = option.value;
            const selected = selectedOption && selectedOption.value === optionValue;

            return (
              <div
                className={classnames(styles.radio, { [styles['radio-selected']]: selected })}
                key={optionValue}
              >
                <input
                  type="radio"
                  id={radioItemId}
                  name={radioGroupId}
                  checked={selected}
                  onChange={() => setSelectedOption(option)}
                />
                <label htmlFor={radioItemId}>{option.label}</label>
                {option.secondaryOption && (
                  <div className={styles['radio-secondary-opt']}>{option.secondaryOption}</div>
                )}
              </div>
            );
          })}
        {secondaryOption && <div className={styles['secondary-opt']}>{secondaryOption}</div>}
      </fieldset>
      {selectedOption && (
        <div className={styles.playback}>
          <Icon icon="policygeniusSymbol" height="42px" width="42px" className={styles.genius} />
          <UtilityText size="medium" className={styles['playback-text']}>
            {selectedOption.playback}
          </UtilityText>
        </div>
      )}
      <div className={styles.buttonWrapper}>
        <SubmitButton
          analyticsSource={analyticsProperties.source}
          analyticsText={analyticsProperties.text}
          className={classnames(styles['continue-button'])}
          invalid={!selectedOption}
          submitting={false}
          fullWidth={isMobile}
        />
      </div>
    </form>
  );
};

export default MultipleChoice;
